import { SessionStorageActionTypes as ActionTypes } from './actionTypes';
import { setApolloSessionStorageKey, getApolloSessionStorageKey, } from './helpers';
/**
 * Injects the current SessionStorage state for the apollo-namespaced
 * SessionStorage key into a callback function.
 * @returns function that injects current SessionStorage data into a callback parameter
 */
export const withSessionStorageState = () => {
    const currentApolloSessionStorageState = getApolloSessionStorageKey();
    return (callback) => {
        callback(currentApolloSessionStorageState);
    };
};
/**
 * Reducer for the SessionStorage updates
 * @param state current SessionStorage state for apollo-namespaced SessionStorage key
 * @param action action to be dispatched
 */
export const reducer = (state, action) => {
    switch (action.type) {
        case ActionTypes.SET_APOLLO_SESSION_STORAGE_KEYS:
            setApolloSessionStorageKey({ ...state, ...action.payload });
            break;
        default:
            throw new Error('Invalid action type');
    }
};
/**
 * Dispatches an action to a SessionStorage state-injected reducer
 * @param action SessionStorage action to be dispatched
 * @param _reducer reducer dependency injection
 */
export const dispatch = (action, _reducer = reducer) => {
    withSessionStorageState()((state) => _reducer(state, action));
};
